import React, { useState } from 'react';
import LineOfBusinessSelector from './index';

// eslint-disable-next-line react/prop-types
export const ClientLobSelection = ({ clients, businessLines: userBusinessLines, onChange }) => {
  const [businessLinesByClient, setBusinessLinesByClient] = useState({});
  return (
    <ul>
      {clients
        // eslint-disable-next-line react/prop-types
        .filter(({ businessLines }) => businessLines.length > 0)
        .map(({ businessLines, name: clientName, id }) => {
          // eslint-disable-next-line react/prop-types
          const businessLinesByLob = businessLines.reduce(
            (lobs, bl) => ({
              ...lobs,
              [bl.name]: bl,
            }),
            {}
          );
          const selected = (userBusinessLines || [])
            .filter(({ clientId }) => id === clientId)
            .map(({ name }) => name);
          return (
            <li>
              <div>
                <LineOfBusinessSelector
                  title={clientName}
                  // eslint-disable-next-line react/prop-types
                  options={businessLines.map(({ name }) => name)}
                  selected={selected}
                  onChange={selectedLob => {
                    const lob = {
                      ...businessLinesByClient,
                      [clientName]: selectedLob.map(name => businessLinesByLob[name].id),
                    };
                    setBusinessLinesByClient(lob);
                    onChange(Object.values(lob).flat());
                  }}
                />
              </div>
            </li>
          );
        })}
    </ul>
  );
};

export default ClientLobSelection;
